/**
 * Image Hover - Frontend
 *
 * On hover, cycles through the uploaded image pool at a fixed interval.
 * On mouseleave, snaps back to the primary (first) image.
 *
 * When the block is inside a linked group (.wp-block-group.is-linked), the
 * group's overlay <a> intercepts all pointer events. In that case we listen on
 * the <a> directly and use getBoundingClientRect to only cycle when the cursor
 * is actually over this block.
 *
 * A shared custom cursor element follows the mouse and replaces the default
 * cursor while hovering over any initialized block.
 */

const BLOCK_SELECTOR = '.wp-block-amp-child-theme-image-hover';

const SPEED_MAP = {
	slow:   1400,
	normal:  850,
	fast:    450,
};

function createCursor() {
	const el = document.createElement('div');
	el.className = 'image-hover-cursor';
	el.setAttribute('aria-hidden', 'true');
	el.textContent = 'Learn more';
	document.body.appendChild(el);
	return el;
}

function initImageHover() {
	const blocks = document.querySelectorAll(BLOCK_SELECTOR);
	if (!blocks.length) return;

	const cursor = createCursor();

	const showCursor = () => cursor.classList.add('is-visible');
	const hideCursor = () => cursor.classList.remove('is-visible');
	const moveCursor = (x, y) => {
		cursor.style.left = `${x}px`;
		cursor.style.top  = `${y}px`;
	};

	blocks.forEach((block) => {
		const imgs = block.querySelectorAll('.image-hover-img');
		if (imgs.length < 2) return;

		const speed = block.dataset.speed || 'normal';
		const cycleInterval = SPEED_MAP[speed] ?? SPEED_MAP.normal;

		let timerId = null;
		let currentIndex = 0;

		imgs[0].classList.add('is-active');
		block.classList.add('js-initialized');

		const startCycling = () => {
			if (timerId) return;
			timerId = setInterval(() => {
				imgs[currentIndex].classList.remove('is-active');
				currentIndex = (currentIndex + 1) % imgs.length;
				imgs[currentIndex].classList.add('is-active');
			}, cycleInterval);
		};

		const stopCycling = () => {
			clearInterval(timerId);
			timerId = null;
			imgs[currentIndex].classList.remove('is-active');
			currentIndex = 0;
			imgs[0].classList.add('is-active');
		};

		const group = block.closest('.wp-block-group.is-linked');
		const groupLink = group?.querySelector(':scope > .wp-block-group__link');

		if (groupLink) {
			let overImage = false;

			groupLink.addEventListener('mousemove', (e) => {
				const rect = block.getBoundingClientRect();
				const nowOver = (
					e.clientX >= rect.left &&
					e.clientX <= rect.right &&
					e.clientY >= rect.top &&
					e.clientY <= rect.bottom
				);

				if (nowOver) {
					moveCursor(e.clientX, e.clientY);
					if (!overImage) { overImage = true; showCursor(); startCycling(); }
				} else if (!nowOver && overImage) {
					overImage = false;
					hideCursor();
					stopCycling();
				}
			});

			groupLink.addEventListener('mouseleave', () => {
				overImage = false;
				hideCursor();
				stopCycling();
			});
		} else {
			block.addEventListener('mouseenter', (e) => { moveCursor(e.clientX, e.clientY); showCursor(); startCycling(); });
			block.addEventListener('mouseleave', () => { hideCursor(); stopCycling(); });
			block.addEventListener('mousemove', (e) => moveCursor(e.clientX, e.clientY));
		}
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initImageHover);
} else {
	initImageHover();
}
